import { ChangeEvent, FC, useCallback, useEffect, useMemo } from "react";
import { Field } from "../FieldHandler";

const DropdownField: FC<{
  field: Field & { type: "dropdown" };
  onChange: (key: string, value: string | undefined) => void;
}> = (props) => {
  const { field, onChange } = props;

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      const id = field.key;
      const value = e.target.value;
      onChange(id, value);
    },
    [field, onChange]
  );

  const options = useMemo(() => (Array.isArray(field.options) ? [...field.options] : field.options.split("\n")), [field.options]);

  useEffect(() => {
    if (options.length > 0 && ((field.value && !options.includes(field.value)) || (field.required && !field.value))) {
      onChange(field.key, options[0]);
    }
  }, [field.key, field.required, field.value, onChange, options]);

  return (
    <select key={field.key} value={field.value || ""} onChange={handleChange}>
      {options.map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
      {!field.required ? <option value={""}></option> : null}
    </select>
  );
};

export default DropdownField;
